import React from 'react';
import PropTypes from 'prop-types';
import DateRangePicker from 'components/kea/DateRangePicker';
import styles from './AnalyticsDateRangePicker.module.scss';

const AnalyticsDateRangePicker = (props) => (
  <DateRangePicker {...props} buttonClassName={styles.button} />
);

AnalyticsDateRangePicker.propTypes = {
  timeframe: PropTypes.shape({
    from: PropTypes.any,
    to: PropTypes.any,
  }),
  onSubmitRange: PropTypes.func,
  isFetching: PropTypes.bool,
  localizeMessage: PropTypes.func,
};

AnalyticsDateRangePicker.defaultProps = {
  timeframe: null,
  onSubmitRange: null,
  isFetching: false,
  localizeMessage: null,
};

export default AnalyticsDateRangePicker;
